import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedRow: null,
  formData: {
    adj_id: '',
    adj_date: '',
    adj_descr: '',
    adj_posted: 0,
    periode_id: '',
    location: '',
    location_id: '',
    adj_createdby: '',
    adj_createddate: '',
    adj_modifyby: '',
    adj_modifydate: '',
    rowid: '',
    detail: [],
    log: [],
    tabs: {
      detail: 'Detil',
      log: 'Log',
      record: 'Record',
    },
  },
  dataList: [],
  totalData: 0,
  loading: false,
  error: null,
  loadingMessage: '',
  activeTab: 0,
  selectedDetailId: null,
};

const inv07adjSlice = createSlice({
  name: 'inv07adj',
  initialState,
  reducers: {
    setSelectedRow: (state, action) => { state.selectedRow = action.payload; },
    setFormData: (state, action) => { state.formData = action.payload; },
    clearFormData: (state) => { state.formData = initialState.formData; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
    fetchDetailSuccess: (state, action) => {
      state.formData = {
        ...initialState.formData,
        ...action.payload,
        detail: action.payload?.detail || [],
        log: action.payload?.log || [],
        tabs: action.payload?.tabs || initialState.formData.tabs,
      };
      state.loading = false;
      state.error = null;
    },
    fetchDetailFailure: (state, action) => { state.loading = false; state.error = action.payload; },
    fetchDetailError: (state, action) => { state.loading = false; state.error = action.payload; },
    updateFormData: (state, action) => {
      state.loading = false;
      state.formData = { ...state.formData, ...action.payload };
    },
    setDetailData: (state, action) => {
      state.formData.detail = action.payload;
    },
    setSelectedDetailId: (state, action) => {
      state.selectedDetailId = action.payload;
    },
    resetState: () => initialState,
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    clearModuleState: (state) => {
      state.activeTab = 0;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.selectedRow = null;
      state.selectedDetailId = null;
      state.formData = initialState.formData;
    },
  },
});

export const {
  setSelectedRow,
  setFormData,
  clearFormData,
  setLoading,
  setErrorMsg,
  setLoadingMessage,
  setDataList,
  setTotalData,
  fetchDetailSuccess,
  fetchDetailFailure,
  fetchDetailError,
  updateFormData,
  setDetailData,
  resetState,
  setActiveTab,
  clearModuleState,
  setSelectedDetailId,
} = inv07adjSlice.actions;

export default inv07adjSlice.reducer;
